<!--All Periods-->
<div class="as-Table">
	<p-table
		#mydt
		[value]="lstPeriod"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPeriods"
		dataKey="PeriodID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PeriodNo-->
				<th>
					<p-columnFilter type="text" field="PeriodNo" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PeriodDesc-->
				<th>
					<p-columnFilter type="text" field="PeriodDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartTime-->
				<th></th>

				<!--EndTime-->
				<th></th>

				<!--TardyTime-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PeriodNo">Period Number<p-sortIcon field="PeriodNo"></p-sortIcon></th>
				<th pSortableColumn="PeriodDesc">Description<p-sortIcon field="PeriodDesc"></p-sortIcon></th>
				<th pSortableColumn="StartTimeDate">Start Time<p-sortIcon field="StartTimeDate"></p-sortIcon></th>
				<th pSortableColumn="EndTimeDate">End Time<p-sortIcon field="EndTimeDate"></p-sortIcon></th>
				<th pSortableColumn="TardyTimeDate">Tardy Time<p-sortIcon field="TardyTimeDate"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-period>
			<tr [pSelectableRow]="period">
				<td>
					<p-tableCheckbox [pSelectableRow]="period" [value]="period"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ period[col.field] }}
				</td>

				<td>
					<p-calendar
						[(ngModel)]="period.StartTimeDate"
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
					></p-calendar>
				</td>

				<td>
					<p-calendar
						[(ngModel)]="period.EndTimeDate"
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
					></p-calendar>
				</td>

				<td>
					<p-calendar
						[(ngModel)]="period.TardyTimeDate"
						showIcon="true"
						showButtonBar="true"
						showTime="true"
						hourFormat="12"
						timeOnly="true"
					></p-calendar>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="TextCenter TopMargin BottomMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
